import { render, staticRenderFns } from "./SkyboxAdd.vue?vue&type=template&id=58af1883&scoped=true&"
import script from "./SkyboxAdd.vue?vue&type=script&lang=js&"
export * from "./SkyboxAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af1883",
  null
  
)

export default component.exports